const STORAGE_KEY = 'events_trial_token_v1';

export function storeEventsTrialToken(token: string): void {
  sessionStorage.setItem(STORAGE_KEY, token);
}

export function getEventsTrialToken(): string | undefined {
  return sessionStorage.getItem(STORAGE_KEY) || undefined;
}

export function clearEventsTrialToken(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
